import { NgModule } from "@angular/core";
import { Route, RouterModule } from "@angular/router";
import { ValuationReportTemplateListComponent } from "./valuation-report-template-list/valuation-report-template-list.component";
import { ValuationReportTemplateFormComponent } from './valuation-report-template-form/valuation-report-template-form.component'
import { ValuationReportTemplateEditComponent } from './valuation-report-template-edit/valuation-report-template-edit.component'
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { PartialsModule } from "src/app/views/partials/partials.module";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { DraggableModule } from "../draggable/draggable.module";
import { MatSelectModule } from "@angular/material/select";
import { MatDialogModule } from "@angular/material/dialog";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { ValuationReportTemplateEditModalComponent } from "./valuation-report-template-edit-modal/valuation-report-template-edit-modal.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PartialsModule,
    RouterModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    DragDropModule,
    DraggableModule,
    MatSelectModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSlideToggleModule
  ],
  declarations: [
    ValuationReportTemplateListComponent,
    ValuationReportTemplateFormComponent,
    ValuationReportTemplateEditComponent,
    ValuationReportTemplateEditModalComponent
  ],
  exports: [
    ValuationReportTemplateEditModalComponent
  ]
})
export class ValuationReportTemplateModule {}